import script from "./AlertPop.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertPop.vue?vue&type=script&setup=true&lang=js"

import "./AlertPop.vue?vue&type=style&index=0&id=35e576ef&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e576ef"]])

export default __exports__